import { render } from "./IconShooting.vue?vue&type=template&id=7b34ea18&ts=true"
import script from "./IconShooting.vue?vue&type=script&lang=ts"
export * from "./IconShooting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__